// src/theme/theme247mui.ts
import { createTheme } from '@mui/material/styles';

const theme247mui = createTheme({
  palette: {
    mode: 'light',
    common: {
      black: '#212121',
      white: '#ffffff',
    },
    background: {
      default: '#F5F5F5',
      paper: '#fff',
    },
    primary: {
      // main: '#0E3F51',
      main: '#006499',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#38748D',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FF3D00',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FF8256',
      contrastText: '#ffffff',
    },
    info: {
      main: '#707070',
    },
    success: {
      main: '#7CB342',
      contrastText: '#ffffff',
    },
    text: {
      // primary:"#AF1000",
      primary: '#212121',
      secondary: '#707070',
      disabled: '#757575',
    },
    grey: {
      900: '#AEAEAE',
      800: '#707070',
      700: '#757575',
      500: '#9E9E9E',
      300: '#E0E0E0',
      200: '#EEEEEE',
      100: '#F5F5F5',
      50: '#FAFAFA',
    },
  },
  typography: {
    fontFamily: ['"Rubik"', 'Arial', 'sans-serif'].join(','),
    fontWeightBold: 600,
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          "&:hover": {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme247mui;
